import useAgentData from '~/client/hooks/useAgentData';
import LightThemeProvider from '~/client/shared/ThemeProviders/LightThemeProvider';
import sendInteractionToGtm from '~/shared/gtm/sendInteractionToGtm';
import ProviderCardDesktop from './ProviderCardDesktop';
import ProviderCardMobile from './ProviderCardMobile';
import type { CasinoProviderGameFragment } from '../graphql/ProvidersListQuery.generated';

type Props = {
  name: string;
  handle: string;
  count: number;
  games: CasinoProviderGameFragment[];
};

const ProviderCard: FC<Props> = ({ name, handle, count, games }) => {
  const { isMobile } = useAgentData();
  const sendToGtm = (action?: string) =>
    sendInteractionToGtm({
      eventCategory: 'image_link',
      eventAction: action ?? 'provider_card',
      eventLabel: 'games list',
    });
  return (
    <>
      {isMobile ? (
        <ProviderCardMobile
          name={name}
          handle={handle}
          count={count}
          sendToGtm={sendToGtm}
        />
      ) : (
        <LightThemeProvider>
          <ProviderCardDesktop
            name={name}
            handle={handle}
            count={count}
            games={games}
            sendToGtm={sendToGtm}
          />
        </LightThemeProvider>
      )}
    </>
  );
};

export default ProviderCard;
